import React from 'react';
import {Nav, NavItem, NavLink, TabContent, TabPane} from "reactstrap";
import classnames from 'classnames';
import HTML from '../../common/HtmlHelpers';
import PropTypes from 'prop-types';

/**
 * Simple Renderer for tabs
 */
class TabsRenderer extends React.Component{

    static propTypes = {
        pages: PropTypes.array,
        onActivate: PropTypes.func,
        style: PropTypes.object,
        vertical: PropTypes.bool,
        pills: PropTypes.bool,
        activeTabClassname: PropTypes.string,
        defaultPage:PropTypes.number,
        tabContentStyle: PropTypes.object,
        getTabContentRef: PropTypes.func
    };


    static defaultProps = {
        activeTabClassname: 'active'
    };

    constructor(props){
        super(props);

        this.state = {
            activeTab: props.defaultPage
        };
    }

    getActiveTab(){
        return this.state.activeTab;
    }

    toggle(tab){

        if(this.state.activeTab != tab) {

            this.setState({
                activeTab: tab
            });

            if(this.props.onActivate)
                this.props.onActivate(tab);
        }

    }

    render(){

        const props = this.props;
        const pages = props.pages;
        const activeTab = this.state.activeTab;

        return <div style={this.props.style}>
                <Nav tabs={!this.props.pills} pills={this.props.pills}>
                    {pages.map((p,index) => {

                        const isActive = this.state.activeTab == index;
                        return <NavItem key={index} className={'tab-nav-item'}>
                            <NavLink className={classnames({ active: isActive, [this.props.activeTabClassname]:  isActive })} onClick={() =>  this.toggle(index) }>
                                {HTML.renderIcon(p.icon)} {typeof p.title == "function" ? p.title() : p.title }
                            </NavLink>
                        </NavItem>
                    })}
                </Nav>
                <TabContent  activeTab={this.state.activeTab} style={this.props.tabContentStyle} ref={props.getTabContentRef}>
                    {pages.map((p,index) => {
                        return <TabPane key={index} tabId={index} className={p.className} style={p.style}>
                                {p.render(activeTab == index)}
                        </TabPane>
                    })}

            </TabContent>
        </div>;
    }

}

export default TabsRenderer;


// WEBPACK FOOTER //
// ./src/common/TabsRenderer/TabsRenderer.js